export const getHeaders = (xFingerprint = null, access_token = null) => {
  const headers = { 'Content-Type': 'application/json' };
  if (xFingerprint) headers['X-FINGERPRINT'] = xFingerprint;
  if (access_token) headers.Authorization = 'Bearer ' + access_token;

  return headers;
};
